import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { MINT_100, PropsWithTheme, SAGE_100 } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { displayNumber } from '../../common/utils';
import { useRentOrBuy } from '../data/dataProvider';

const ResultPlate = styled.div`
  margin-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(3)}px`};
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${MINT_100};
  thead {
    background-color: ${SAGE_100};
  }
  th:not(:last-child) {
    border-right: 1px solid ${MINT_100};
  }
  th {
    border-bottom: 1px solid ${MINT_100};
  }
  td {
    border-style: none;
  }
  td:not(:last-child) {
    border-right: 1px solid ${MINT_100};
  }
  td:first-child {
    background-color: ${SAGE_100};
    ${({ theme }) => theme.breakpoints.up('md')} {
      background-color: white;
    }
  }
  tr:not(:last-child) {
    border-bottom: 1px solid ${MINT_100};
  }
`;
const MobileTable = styled.div`
  display: block;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: none;
  }
`;
const DesktopTable = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`;
export const CalculationTableResult: React.FC = () => {
  const {
    getCurrentValueOfHome,
    getTotalOwedToBank,
    getEquityOnHome,
    getNetCostOfBuying,
    getNetCostOfRenting,
    getBenefitOfBuying
  } = useRentOrBuy();
  const data = [
    { label: 'Value of Home at Selling', value: getCurrentValueOfHome() },
    { label: 'Total Owed to Bank at Selling', value: getTotalOwedToBank() },
    { label: 'Equity on Home at Selling', value: getEquityOnHome() },
    { label: 'Cost of Buying', value: getNetCostOfBuying() },
    { label: 'Cost of Renting', value: getNetCostOfRenting() },
    { label: 'Benefits of Buying', value: getBenefitOfBuying() }
  ];
  const renderTableRow = (isDesktop = false) =>
    isDesktop ? (
      <TableRow>
        {data.map((item, index) => (
          <TableCell key={index}>{displayNumber(item.value)}</TableCell>
        ))}
      </TableRow>
    ) : (
      <>
        {data.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item.label}</TableCell>
            <TableCell>{displayNumber(item.value)}</TableCell>
          </TableRow>
        ))}
      </>
    );
  return (
    <>
      <MobileTable>
        <ResultPlate>
          <Table size="small" aria-label="a dense table">
            <TableBody>{renderTableRow()}</TableBody>
          </Table>
        </ResultPlate>
      </MobileTable>
      <DesktopTable>
        <ResultPlate>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                {data.map((item, index) => (
                  <TableCell key={index}>{item.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{renderTableRow(true)}</TableBody>
          </Table>
        </ResultPlate>
      </DesktopTable>
    </>
  );
};
